import Box from "@mui/material/Box";
import styled from "@mui/system/styled";
import { keyframes } from "@emotion/react";
import {
  flexType,
  styleType,
  styledAnimatedBoxType,
  animatedSlideInType,
} from "./box.types";

export const StyledBoxVarientOne = styled(Box)(({ theme }) => ({
  padding: "20px 10px 20px 10px",
  [theme.breakpoints.between("xs", "sm")]: {
    padding: "15px 16px 0px 16px",
  },
  [theme.breakpoints.between("sm", "md")]: {
    padding: "15px 0px 0px 0px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "20px 20px 20px 15px",
  },
}));

export const StyledBoxVarientTwo = styled(Box)(({ theme }) => {
  return {
    // padding: "0px 15px 0px 15px",
    [theme.breakpoints.between("xs", "md")]: {
      padding: "0px 16px 0px 16px",
    },
    [theme.breakpoints.up("md")]: {
      padding: "0px 20px 0px 20px",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "0rem 1.75rem 0rem 1.75rem",
    },
  };
});

const StyledCenterAlignedFlexCol = styled(Box)(
  ({ style, direction }: styleType) =>
    style
      ? {
          display: "flex",
          flexDirection: direction,
          alignItems: "center",
          ...(style["xl"] ||
            style["lg"] ||
            style["md"] ||
            style["sm"] ||
            style["xs"]),
          "@media(max-width:1520px)": {
            ...(style["lg"] || style["md"] || style["sm"] || style["xs"]),
          },
          "@media(max-width:12000px)": {
            ...(style["md"] || style["sm"] || style["xs"]),
          },
          "@media(max-width:900px)": {
            ...(style["sm"] || style["xs"]),
          },
          "@media(max-width:600px)": {
            ...style["xs"],
          },
        }
      : { display: "flex", flexDirection: "column", alignItems: "center" },
);
export const CenterAlignedFlexCol = ({
  children,
  style,
  direction = "row",
}: flexType) => {
  return (
    <StyledCenterAlignedFlexCol style={style} direction={direction}>
      {children}
    </StyledCenterAlignedFlexCol>
  );
};

const translateLeft = keyframes`
  0% {
    translate:-150px;
    opacity:1;
 
  }
   
  50%{
     translate:-50px;
     opacity:0.5;
      
  }
  100%{
    transform: translate 0px;
    opacity:0;
    
  }
`;

const translateRight = keyframes`
  0% {
    translate:150px;
    opacity:1;
   
    
  }
   
  50%{
     translate:50px;
     opacity:0.5;
   
     
  }
  100%{
   translate:0px;
    opacity:0;
  
   
  }
`;
const leftToRight = keyframes`
  0% {
    translate:-250px;
    opacity:1;
   
  }
   
  50%{
     translate:-50px;
     opacity:0.5;
     
  }
  100%{
    translate:0px;
    opacity:0;
  
  }
`;
const rightToLeft = keyframes`
  0% {
    translate:250px;
    opacity:1;
  
  }
   
  50%{
     translate:50px;
     opacity:0.5;

  }
  100%{
    translate:0px;
    opacity:0;

  }
`;

const StyledAnimatedBox = styled(Box)(({
  direction,
}: styledAnimatedBoxType) => {
  if (direction === "left") {
    return {
      animation: `${translateLeft} 300ms ease-in`,
    };
  }
  if (direction === "right") {
    return {
      animation: `${translateRight} 300ms ease-in`,
    };
  }
  if (direction === "leftToRight") {
    return {
      animation: `${leftToRight} 300ms ease-in`,
    };
  }
  if (direction === "rightToLeft") {
    return {
      animation: `${rightToLeft} 300ms ease-in`,
    };
  }
});

export const AnimatedSlideIn = ({
  children,
  direction,
}: animatedSlideInType) => {
  return (
    <StyledAnimatedBox direction={direction}>{children}</StyledAnimatedBox>
  );
};
